export default __webpack_public_path__ + "static/media/1940.1ba62fef.png";